import Inbox from "./Inbox";
import Icon from "./InboxIcon"

export default Inbox;
export const InboxIcon = Icon;